module.exports = __webpack_public_path__ + "img/u2012.f6fa9689.png";